import React, { useState } from 'react';
import {
    Box,
    Chip,
    IconButton,
    Menu,
    MenuItem, 
    Stack,
    Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import SupportDialog from './Support';
import { useDialog } from '../../hooks/useDialog';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import HelpOutlinedIcon from '@mui/icons-material/HelpOutlined';
import { ReactComponent as Logo } from '../../logo2.svg';

export default function Header({
    company, seat, readOnly
}) {
    const {t, i18n} = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);
    const isLanguageMenuOpen = Boolean(anchorEl);
    const {openDialog, closeDialog, isOpen} = useDialog();

    const handleLanguageMenuClose = () => {
        setAnchorEl(null);
    };

    const handleLanguageClick = (e) => {
        setAnchorEl(e.currentTarget);
    };

    const handleLanguageSelect = (lang) => {
        i18n.changeLanguage(lang)
        handleLanguageMenuClose();
    };

    return ( <>
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start', // Align children to top
                p: 1
            }}
        >
            {/* Left-side (Seat Label - top-left) */}
            <Box
                sx={{
                    display: 'flex',
                    flexShrink: 0,
                    alignSelf: 'flex-start',
                }}
            >
                <Chip label={seat?.label ? seat.label : 'Read Only'}/>
            </Box>

            {/* Center (Logo + Company Name) */}
            <Stack direction="column" alignItems="center">
                {company.logo ? (<img src={company.logo} alt="Logo" style={{ maxWidth: '200px', height: 'auto' }} />) : (<Logo width="200px" height="auto" />)}
            </Stack>

            {/* Right-side (Icons - top-right) */}
            <Box
                sx={{
                    display: 'flex',
                    flexShrink: 0,
                    alignSelf: 'flex-start',
                }}
            >
                <IconButton onClick={handleLanguageClick} sx={{p: 0}}>
                    <LanguageOutlinedIcon sx={{ fontSize: 32 }} />
                </IconButton>
                <Menu
                    anchorEl={anchorEl}
                    open={isLanguageMenuOpen}
                    onClose={handleLanguageMenuClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                >
                    <MenuItem onClick={() => handleLanguageSelect('en')}>
                        {t('langSelectEn')}
                    </MenuItem>
                    <MenuItem onClick={() => handleLanguageSelect('es')}>
                        {t('langSelectEs')}
                    </MenuItem>
                </Menu>
                <IconButton disabled={readOnly} onClick={() => openDialog('support')} sx={{p: 0, ml: 1}}>
                    <HelpOutlinedIcon sx={{ fontSize: 32 }} />
                </IconButton>
            </Box>

            <SupportDialog
                company={company}
                seat={seat}
                isOpen={isOpen}
                openDialog={openDialog}
                closeDialog={closeDialog}
            />
        </Box>
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
            }}>
            <Typography variant='overline' fontSize={14}>
                {company.name}
            </Typography>
        </Box>        
    </>);
}
